export class Position {
    public id: string;
    public name: string;
  
    constructor(raw: object) {
      this.id = raw['childpositionid'];
      this.name = raw['childposition'];
    }
  }